import { alpha } from "@/lib/forumColors";

/** Donut chart of the forum split for one day. Pure SVG, no chart library. */
export const ForumDonut = ({ slices = [], size = 46, thickness = 7, testId }) => {
  const total = slices.reduce((sum, s) => sum + s.count, 0);
  const radius = (size - thickness) / 2;
  const circumference = 2 * Math.PI * radius;
  let offset = 0;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      data-testid={testId}
      className="shrink-0"
      role="img"
      aria-label={`${total} listing(s) by forum`}
    >
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        strokeWidth={thickness}
        stroke={total ? alpha("#94A3B8", 0.25) : alpha("#94A3B8", 0.35)}
      />
      {total
        ? slices.map((slice) => {
            const length = (slice.count / total) * circumference;
            const dash = `${length} ${circumference - length}`;
            const rotation = (offset / circumference) * 360 - 90;
            offset += length;
            return (
              <circle
                key={slice.key || slice.name}
                cx={size / 2}
                cy={size / 2}
                r={radius}
                fill="none"
                stroke={slice.color}
                strokeWidth={thickness}
                strokeDasharray={dash}
                strokeLinecap="butt"
                transform={`rotate(${rotation} ${size / 2} ${size / 2})`}
              />
            );
          })
        : null}
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dominantBaseline="central"
        className="fill-foreground"
        style={{ fontSize: size * 0.34, fontWeight: 700 }}
      >
        {total}
      </text>
    </svg>
  );
};
